import { render, staticRenderFns } from "./HomeScreen.vue?vue&type=template&id=0019c754&scoped=true&"
import script from "./HomeScreen.vue?vue&type=script&lang=js&"
export * from "./HomeScreen.vue?vue&type=script&lang=js&"
import style0 from "./HomeScreen.vue?vue&type=style&index=0&id=0019c754&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0019c754",
  null
  
)

export default component.exports